
<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-02-02 17:08:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-07 14:21:49
 * @FilePath: \VUE3\src\pages\caiwu\views\gongzi\gongzifafang\add.vue
-->
<template>
  <div>
    <el-dialog class="w600 h430" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">工资发放</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="发放日期" prop="ffrq" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.ffrq" type="date" value-format="YYYY-MM-DD"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      const date = new Date()
      const year = date.getFullYear() // 获取完整的年份(4位)
      let month = date.getMonth() + 1 // 获取当前月份(0-11,0代表1月)
      let strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`
      ruleForm.value.ffrq = `${year}-${month}-${strDate}`
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  closeWindow('openAdd', emits, false)
  emits('ReturnData', ruleForm.value)
}
</script>
